<template>
    <div class="conditions-utilisation-contaienr pt-40 px-3 px-lg-0">
        <h1 class="title text-center pb-3 fw-medium text-gray-900">Conditions d’Utilisation</h1>
        <p class="text-center text-gray-500 fw-medium mb-xs-32 mb-xl-64">Dernière mise à jour : 7 Décembre 2023</p>
        <div class="pe-xs-0 pe-xl-80 pb-80">
        <p class="text-gray-500 pt-xs-32 pt-xl-64 pb-xs-32 pb-xl-80">Bienvenue sur Topauto. En utilisant notre plateforme, vous acceptez les conditions énoncées ci-dessous. Veuillez lire attentivement ces Conditions d’Utilisation avant de naviguer, vendre ou acheter sur Topauto.</p>
        <div v-for="(section, index) in content" :key="index">
            <h2 class="SectionTitle text-gray-900 fw-bold">{{ section.title }}</h2>
            <div class="SectionBody pt-3 pb-40 text-gray-600" v-if="typeof section.body === 'string'">
              <p >{{ section.body }}</p>
            </div>
            <div class="SubSection pb-40" v-else>
              <div class="pt-3" v-for="(subSection, subIndex) in section.body" :key="subIndex">
                <p class="SubSectionTitle-body text-gray-600"><span class="fw-bold text-gray-900">{{ subSection.subTitle }}&nbsp;</span>{{ subSection.body }}</p>
              </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const runTimeConfig = useRuntimeConfig();
const route = useRoute();

definePageMeta({
  layout: 'terms-layout',
});

const seoUrl = ref();
const seoImage = ref();

const seoTitle = `Conditions d'Utilisation - TopAuto`;
const seoDescription = `Consultez les conditions d'utilisation de TopAuto. Découvrez les règles et responsabilités pour utiliser notre plateforme de vente de voitures d'occasion en Tunisie.`;
seoUrl.value = `${runTimeConfig.public.clientBaseUrl}${route.fullPath}`;
seoImage.value = `${runTimeConfig.public.clientBaseUrl}/_nuxt/assets/images/logos/Logo.png`;

useHead({
  title: seoTitle,
  link: [
    {
      rel: 'canonical',
      href: seoUrl
    }
  ],
  meta: [
    {
      name: 'description',
      content: seoDescription
    },
    {
      property: 'og:title',
      content: seoTitle
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:description',
      content: seoDescription
    },
    {
      property: 'og:url',
      content: seoUrl
    },
    {
      property: 'og:image',
      content: seoImage
    },
    {
      property: 'og:site_name',
      content: 'TopAuto'
    }
  ]
});

const content = ref([
    {

        title: '1.Acceptation des Conditions',
        body: "En utilisant Topauto, vous acceptez de respecter et d’être lié par ces Conditions d’Utilisation. Si vous n’acceptez pas ces conditions, veuillez ne pas utiliser notre plateforme."
    },
    {
        title:'2.Utilisation du Service',
        body:[
            {subTitle: "1. Eligibilité :", body:"Vous devez avoir au moins 18 ans pour utiliser nos services. En utilisant Topauto, vous déclarez avoir l’âge requis."},
            {subTitle: "2. Compte :", body:"Certains services peuvent nécessiter la création d’un compte. Vous êtes responsable de la confidentialité de vos informations de compte."},
            {subTitle: "3. Contenu :", body:"En soumettant du contenu sur Topauto, vous accordez à Topauto une licence mondiale, non exclusive, gratuite, transférable pour utiliser, afficher, reproduire et distribuer ce contenu"},
            
        ]
    },
    {
        title:"3. Responsabilités de l’Utilisateur",
        body:[
            {subTitle: "1. Exactitude des Informations :", body:"En tant qu’utilisateur, vous êtes responsable de l’exactitude des informations que vous fournissez sur Topauto."},
            {subTitle: "2. Conduite Conforme :", body:"Vous acceptez de ne pas utiliser Topauto à des fins illégales ou interdites par ces conditions."},
            {subTitle: "3. Respect des Droits des Autres :", body:"Vous acceptez de ne pas porter atteinte aux droits d’autrui, y compris les droits de propriété intellectuelle."},
        ]
    },
    {
        title:"4. Politique de Confidentialité",
        body:"Votre utilisation de Topauto est également régie par notre Politique de Confidentialité. En utilisant notre plateforme, vous consentez à notre collecte, utilisation et partage d’informations conformément à cette politique."
    },
    {
        title:"5. Modifications des Conditions",
        body:"Topauto se réserve le droit de modifier ces Conditions d’Utilisation à tout moment. Les modifications seront publiées sur cette page avec la date de la dernière mise à jour. Il est de votre responsabilité de vérifier régulièrement les mises à jour."
    },
    {
        title:"6. Résiliation",
        body:"Topauto se réserve le droit de résilier ou suspendre votre compte à sa seule discrétion, avec ou sans préavis, pour non-respect de ces Conditions d’Utilisation."
    },
    {
        title:"7. Contactez-nous",
        body:"Si vous avez des questions concernant ces Conditions d’Utilisation, veuillez nous contacter à contact@topauto.tn."
    }
]);
</script>

<style scoped>

</style>